/**
 * Handles Ctrl/Cmd + Enter (add row) and Ctrl/Cmd + Backspace (delete row)
 * keyboard shortcuts for Handsontable instances.
 *
 * Usage in hotSettings:
 *   afterDocumentKeyDown(event) {
 *     handleHotKeyboardShortcut(event, { onAddRow, onDeleteRow })
 *   }
 */
export function handleHotKeyboardShortcut(event, { onAddRow, onDeleteRow }) {
  if (!(event.ctrlKey || event.metaKey)) return

  if (event.key === 'Enter' && onAddRow) {
    event.preventDefault()
    onAddRow()
  } else if (event.key === 'Backspace' && onDeleteRow) {
    event.preventDefault()
    onDeleteRow()
  }
}
